export default "__VITE_ASSET__BzEI5mBx__"